import React, { useState } from 'react'
import { Box, Button, Flex } from '@chakra-ui/react'
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import './datepicker-styles.css'
import { es } from 'date-fns/locale';

interface DateSelectorProps {
  startDate: any,
  endDate: any,
  handleOnChangeDates: (dates: any) => void,
  handleClear: () => void,
  handleApply: () => void
}

const DateSelector = ({endDate, startDate, handleApply, handleClear, handleOnChangeDates}: DateSelectorProps) => {
  const [today] = useState(new Date())
  const [error, setError] = useState<string | null>(null);

  const handleLimitedChange = (dates: any) => {
    const [start, end] = dates;
    if (start && end) {
      const diff = Math.abs((end - start) / (1000 * 60 * 60 * 24));
      if (diff > 31) {
        setError('El rango de fechas no puede exceder un mes');
        return;
      } else {
        setError(null);
      }
    } else {
      setError(null);
    }
    handleOnChangeDates(dates);
  };

  return <>
    <Box p={2} width="250px" maxWidth="100%">
      <DatePicker
        selectsRange
        startDate={startDate}
        endDate={endDate}
        isClearable={true}
        locale={es}
        showYearDropdown
        showMonthDropdown
        dropdownMode="select"
        onChange={handleLimitedChange}
        inline
      />
      {error && (
        <Box color="red.500" fontSize="sm" my={2} textAlign="center" width="100%" wordBreak="break-word" whiteSpace="pre-line" display="block">
          {error}
        </Box>
      )}
      <Flex justify="space-between">
        <Button variant="ghost"
          onClick={handleClear}
          p="xl">
          Limpiar
        </Button>
        <Button
          p="xl"
          onClick={handleApply}
          colorScheme='button-primary'>
          Aplicar
        </Button>
      </Flex>
    </Box>
  </>
}

export default DateSelector
